import React from 'react';

import { useCXI } from 'modules/cxi/useCXI';

import moment from 'moment';
import { Trans } from 'react-i18next';
import { ChecklistStage1 } from './ChecklistStage1';
import { ChecklistStage2 } from './ChecklistStage2';
import { ChecklistStage3 } from './ChecklistStage3';
import * as Styled from './StyledChecklist';

export const Checklist = () => {
    const { t, vars } = useCXI();
    const { cxi } = vars;

    const { currentStage, stage1Date, stage2Date, stage3Date } = cxi;

    const renderStage = React.useMemo(() => {
        if (currentStage === 1) {
            return <ChecklistStage1 />;
        }
        if (currentStage === 2) {
            return <ChecklistStage2 />;
        }
        if (currentStage === 3) {
            return <ChecklistStage3 />;
        }
        return <>{t('home.Checklist.empty')}</>;
    }, [t, currentStage]);

    const renderDayDiff = React.useMemo(() => {
        const stageDate = stage3Date || stage2Date || stage1Date || undefined;
        const expectedDate = moment(stageDate).add(90, 'days');
        const todayDate = moment();
        return expectedDate.diff(todayDate, 'days');
    }, [stage3Date, stage2Date, stage1Date]);

    let days = renderDayDiff;
    let i18nKey = 'home.Checklist.title';
    if (renderDayDiff < 0) {
        days = renderDayDiff * -1;
        i18nKey = 'home.Checklist.delay';
    }

    return (
        <Styled.Checklist>
            <Styled.ChecklistTitle>
                <Trans className="text" i18nKey={i18nKey} t={t} days={{ days }}>
                    Você tem <strong>{{ days }}</strong> dias para:
                </Trans>
            </Styled.ChecklistTitle>
            {renderStage}
        </Styled.Checklist>
    );
};
